export class User {
    
    id: number;
    userId: string;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    displayName: string = "";
    role: string;
    displayRole: string;
    dateOfBirth: string;
    phoneNumber: string;
    emailresult: string;
    roleNames: string[];
}
